import { render } from "./AddressList.vue?vue&type=template&id=21f09dfe&scoped=true"
import script from "./AddressList.vue?vue&type=script&lang=js"
export * from "./AddressList.vue?vue&type=script&lang=js"

import "./AddressList.vue?vue&type=style&index=0&id=21f09dfe&lang=scss&scoped=true"

import exportComponent from "F:\\ds_pc_new\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21f09dfe"]])

export default __exports__